import React from 'react'
import styled from 'styled-components'

const ImageContainer = styled.div`
  position: relative;
`
const Image = styled.img`
  max-width: 100%;
`

const Heading = styled.h2`
  color: #fff;

  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;

  margin: 0;
  padding: 60px 0 20px;

  box-shadow: inset 0 -80px 80px -80px #000;
`

const Preamble = styled.div`
  margin: 8px 16px 0;

  > * {
    margin: 0 0 8px;
  }

  ul,
  ol {
    padding-left: 20px;
    margin: 0;
  }

  li[data-list='bullet'] {
    list-style: disc;
  }
`

/**
 * @param {{
 *  service: {
 *    websiteFormImage: {
 *      resourceType: string,
 *      type: string
 *      publicId: string
 *    }
 *    websiteFormHeading: string
 *    websiteFormPreamble: string
 *  }
 * }} props
 */
export const RequestFormHeader = ({ service, hideText = false }) => (
  <div>
    {!!service.websiteFormImage && (
      <ImageContainer>
        <Image
          src={`https://assets.nobiadigital.com/${service.websiteFormImage.resourceType}/${service.websiteFormImage.type}/c_fill,ar_2,h_600/q_auto/f_auto/${service.websiteFormImage.publicId}`}
        />
        <Heading>{service.websiteFormHeading}</Heading>
      </ImageContainer>
    )}
    {!!service.websiteFormPreamble && !hideText && (
      <Preamble
        dangerouslySetInnerHTML={{ __html: service.websiteFormPreamble }}
      />
    )}
  </div>
)
